import { call } from "@/services/api";
import type { SupplierRefs } from "@/lib/cartonLabels";

// Z Production's carton labels: the supplier references per article and the label base's memory.
export type LabelPrefs = Record<string, { supplier_ref: string | null; qty: string | null }>;
export const fetchLabels = () => call<{ supplier_refs: SupplierRefs; prefs: LabelPrefs }>("/api/v1/labels");
export const saveLabelPref = (reference: string, b: { supplier_ref: string; qty: string }) =>
  call<{ reference: string }>(`/api/v1/labels/${encodeURIComponent(reference)}`, {
    method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(b),
  });
